export const API_ROOT =
  process.env.REACT_APP_API_ROOT || "https://dev.avtolog.si"

export const apiRoot = process.env.NODE_ENV === "development" ? API_ROOT : ""

export const profileURL = () => `${apiRoot}/api/profile/`
export const sendSMSURL = () => `${apiRoot}/login/send-sms/`
export const loginURL = () => `${apiRoot}/login/`
export const logoutURL = () => `${apiRoot}/logout/`
export const jsonURL = (key) => `${apiRoot}/api/json/${key}/`
export const garageURL = () => `${apiRoot}/api/json/garage/`
export const contractsURL = () => `${apiRoot}/api/json/contracts/`
